import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskDetailsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-details',
	// /settings/details
	path: '/jira/servicedesk/projects/:projectKey/settings/details',
	exact: true,
};
